export const CHARGERS_LOADING = "charger/loading";
export const CHARGERS_ERROR = "charger/error";
export const CHARGERS_FILTERS = "charger/filters";
export const CHARGERS_LIST = "charger/list";
export const CHARGERS_CREATE = "charger/create";
export const CHARGERS_UPDATE = "charger/update";
export const CHARGERS_DELETE = "charger/delete";

export const CHARGERS_ACTION_LOCK = "charger/action/lock";
export const CHARGERS_ACTION_UNLOCK = "charger/action/unlock";
export const CHARGERS_ACTION_VOICE = "charger/action/voice";
export const CHARGERS_ACTION_OPEN_COVER = "charger/action/open_cover";
export const CHARGERS_ACTION_UPDATE_STATUS = "charger/action/update_status";



// WEBPACK FOOTER //
// ./src/actions/chargers/main/constants.js